// extracted by mini-css-extract-plugin
module.exports = {"background":"VideoBlock_background__W1tnS","image":"VideoBlock_image__N66cx","video":"VideoBlock_video__7WTCX","fullScreenVideo":"VideoBlock_fullScreenVideo__37Wm0"};